export const parseListPage = (value: string | null): number => {
  if (value == null || value === "") {
    return 0;
  }
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 0) {
    return 0;
  }
  return parsed;
};

export const buildListSearch = (
  query: Record<string, string | number>
): string => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (key === "page") {
      if (typeof value === "number" && value > 0) {
        params.set("page", String(value));
      }
      return;
    }
    if (typeof value === "string" && value) {
      params.set(key, value);
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};
